String.prototype.FormatNumberForDisplay = function (fractionalDigits, decpoint, sep) {
    var num = this;
    return new Intl.NumberFormat('de-CH', { maximumFractionDigits: fractionalDigits, minimumFractionDigits: fractionalDigits }).format(parseFloat(num));
};

Number.prototype.FormatNumberForDisplay = function (fractionalDigits) {
    return new Intl.NumberFormat('de-CH', { maximumFractionDigits: fractionalDigits, minimumFractionDigits: fractionalDigits }).format(this);
};

Number.prototype.RoundSwissCurrency = function () {
    num = this.toFixed(2);
    num = (((num * 20).toFixed(0)) / 20).toFixed(2);
    return parseFloat(num);
};

Number.prototype.decimalToTime = function () {
    var n = new Date(0,0);
    n.setSeconds(+this * 60 * 60);
    return n.toTimeString().slice(0, 5);
};

jQuery.fn.extend({
    product: function() {
        var total = 1;
        this.each(function() {
            if ($(this).val()) {
                total = total * parseFloat($(this).val());
            }
        });
        return total;
    },
    sum: function(attrName) {
        var total = 0;
        this.each(function() {
            if ($(this).val()) {
                total = total + parseFloat($(this).val());
            }
            if (attrName && $(this).attr(attrName)) {
                total = total + parseFloat($(this).attr(attrName));
            }
        });
        return total;
    }
});
